import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Container, classNames, Media } from "@opensea/ui-kit";
import { getMediaPropsFromMedia } from "../../../../utils";
import { NarrativeMedia } from "../NarrativeMedia";
import { BackgroundOnlyFragment } from "./BackgroundOnly.fragment";
export function BackgroundOnly(t0) {
  const $ = _c(15);
  const {
    className,
    module: moduleKey
  } = t0;
  let desktopMediaProps;
  let t1;
  if ($[0] !== moduleKey) {
    const moduleData = readFragment(BackgroundOnlyFragment, moduleKey);
    const {
      desktopBackgroundMedia,
      mobileBackgroundMedia
    } = moduleData;
    desktopMediaProps = getMediaPropsFromMedia(desktopBackgroundMedia);
    t1 = getMediaPropsFromMedia(mobileBackgroundMedia);
    $[0] = moduleKey;
    $[1] = desktopMediaProps;
    $[2] = t1;
  } else {
    desktopMediaProps = $[1];
    t1 = $[2];
  }
  const mobileMediaProps = t1;
  let t2;
  if ($[3] !== className) {
    t2 = classNames("py-(--overview-vertical-padding)", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== desktopMediaProps) {
    t3 = desktopMediaProps ? <Media greaterThanOrEqual="xl"><NarrativeMedia isBackground={true} media={desktopMediaProps} /></Media> : null;
    $[5] = desktopMediaProps;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== mobileMediaProps) {
    t4 = mobileMediaProps ? <Media lessThan="xl"><NarrativeMedia isBackground={true} media={mobileMediaProps} /></Media> : null;
    $[7] = mobileMediaProps;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="relative aspect-16/9 max-h-[480px] w-full overflow-hidden rounded-xl border border-border-2">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <Container className={t2}>{t5}</Container>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}